export enum EventType {
    PAGEVIEW = 'pageview',
    CLICK = 'click',
    JOINED = 'joined',
    SIGNIN = 'sign-in',
    SIGNUP = 'sign-up',
    EMOTION = 'emotion'
}
